export const exams = ["ISTQB® Certified Tester - Foundation Level (Syllabus 2018)",
	"ISTQB® Certified Tester - Foundation Level Extension, Agile Tester",
	"GAQM - ISTQB® Certified Tester - Advanced Level Test Manager",
	"GAQM - ISTQB® Certified Tester - Advanced Level Test Analyst",
	"GAQM - ISTQB® Certified Tester - Advanced Level Technical Test Analyst",
	"GAQM - CPST-001: Certified Professional Selenium Tester (CPST)™",
	"GAQM - CSTE-001: Certified Software Testing Engineer (CSTE)®",
	"GAQM - CSATFL-001: Certified Software Automation Tester (CSAT)™ - Foundation Level",
	"GAQM - CSATAL-001: Certified Software Automation Tester (CSAT)™ - Advanced Level",
	"GAQM - CATF-001: Certified Agile Tester (CAT)™ - Foundation",
	"GAQM - CSM-001: Certified Scrum Master (CSM)®",
	"GAQM - CASM-001: Certified Agile Scrum Master (CASM)™",
	"GAQM - CASPO-001: Certified Agile Scrum Product Owner (CASPO)™",
	"GAQM - CAD-001: Certified Agile Developer (CAD)™",
	"GAQM - CSP-410: Certified SAFe Practitioner (CSP)™",
	"GAQM - CAC-001: Certified Agile Coach (CAC)™",
	"GAQM - CAPP: Certified Associate Python Programmer (CAPP)",
	"GAQM - CPPP-001: Certified Professional Python Programmer (CPPP)",
	"GAQM - CBAF-001: Certified Business Analyst (CBA)™ - Foundation",
	"GAQM - CPBA: Certified Professional Business Analyst (CPBA)®",
	"GAQM - CSQA-001: Certified Software Quality Analyst (CSQA)™",
	"GAQM - CSQM-001: Certified Software Quality Manager (CSQM)",
	"GAQM - CMAT-001: IMTQN Certified Mobile Application Tester (CMAT) – Foundation Level",
	"GAQM - CAMT-001: IMTQN Certified Advanced Mobile Tester (CAMT)",
	"GAQM - CCTFL-001: Certified Cloud Tester (CCT) - Foundation Level",
	"GAQM - CMCT-001: Certified Mobile Cloud Tester (CMCT)™",
	"GAQM - CCCP-001: Certified Cloud Computing Professional (CCCP)™",
	"GAQM - CCCC-001: Certified Cloud Computing Consultant (CCCC)™",
	"GAQM - CSST-001: Certified Software Security Tester (CSST)™",
	"GAQM - CASST-001: Certified Advanced Software Security Tester (CASST)™",
	"GAQM - BPM-001: Business Process Manager (BPM)®",
	"GAQM - BMP-001: Business Management Professional (BMP)™",
	"GAQM - CBDFS-001: Certified Big Data Foundation Specialist (CBDFS)",
	"GAQM - CBCP-001: Certified BlockChain Professional (CBCP)™",
	"GAQM - CLSSYB-001: Certified Lean Six Sigma Yellow Belt (CLSSYB)™",
	"GAQM - CLSSGB-001: Certified Lean Six Sigma Green Belt (CLSSGB)™",
	"GAQM - CLSSBB-001: Certified Lean Six Sigma Black Belt (CLSSBB)™",
	"GAQM - CLSSMBB-001: Certified Lean Six Sigma Master Black Belt (CLSSMBB)™",
	"Amazon Web Services - CLF-C01: AWS Certified Cloud Practitioner - Foundational",
	"Amazon Web Services - DVA-C01: AWS Certified Developer - Associate",
	"Amazon Web Services - SAA-C01: AWS Certified Solutions Architect - Associate",
	"Amazon Web Services - SOA-C01: AWS Certified SysOps Administrator - Associate",
	"Amazon Web Services - DOP-C00: AWS Certified DevOps Engineer - Professional",
	"Amazon Web Services - SAP-C00: AWS Certified Solutions Architect - Professional",
	"Amazon Web Services - ANS-C00: AWS Certified Advanced Networking - Specialty",
	"Amazon Web Services - BDS-C00: AWS Certified Big Data - Specialty",
	"Amazon Web Services - SCS-C01: AWS Certified Security - Specialty",
	"BCS - BA15: BCS Foundation Certificate in Business Analysis",
	"Blue Prism - AD01: Blue Prism Certified Developer Exam",
	"Blue Prism - AIE01: Installing and Configuring a Blue Prism (Version 5.0) Environment",
	"Blue Prism - AIE02: Installing and Configuring a Blue Prism (Version 6.0) Environment",
	"Blue Prism - ARA01: Blue Prism Certified ROM Architect Exam",
	"Blue Prism - ATA01: Designing a Blue Prism (Version 5.0) Environment",
	"Blue Prism - ATA02: Designing a Blue Prism (Version 6.0) Environment",
	"Check Point - 156-215.77: Check Point Certified Security Administrator [CCSA]",
	"CISCO - 200-125: Cisco Certified Network Associate Exam [CCNA Routing and Switching]",
	"CISCO - 210-260: Implementing Cisco Network Security [CCNA Security]",
	"CISCO - 300-101: CCNP Implementing Cisco IP Routing [CCNP Route]",
	"CISCO - 300-115: Implementing Cisco IP Switched Networks [CCNP Switch]",
	"CISCO - 300-135: Troubleshooting and Maintaining Cisco IP Networks [CCNP TSHOOT]",
	"CISCO - 400-101: CCIE Routing and Switching Written [CCIE Routing and Switching]",
	"CISCO - 400-151: CCIE Data Center Written Exam [CCIE Data Center]",
	"CISCO - 400-251: CCIE Security Written Exam [CCIE Security]",
	"EC-Council - 312-50: Certified Ethical Hacker (CEH v10)",
	"EXIN - ASF: Agile Scrum Foundation",
	"EXIN - ASM: Agile Scrum Master",
	"EXIN - ASPO: Agile Scrum Product Owner</span",
	"EXIN - DEVOPS-F: EXIN DevOps Foundation",
	"EXIN - DEVOPS-P: EXIN DevOps Professional",
	"EXIN - DEVOPS-M: EXIN DevOps Master</span",
	"Fortinet - NSE4-5.4: Fortinet Network Security Expert 4 Written Exam - FortiOS 5.4",
	"IBM - C9010-022: IBM AIX Administration V1",
	"IBM - C9510-401: IBM WebSphere Application Server Network Deployment V8.5.5, System Administration",
	"JNCIS - JN0-343 Enterprise Routing and Switching, Specialist (JNCIS-ENT)",
	"Microsoft - 77-725: MOS: Microsoft Office Word 2016",
	"Microsoft - 77-726: MOS: Microsoft Office Word 2016 Expert",
	"Microsoft - 77-727: MOS: Microsoft Office Excel 2016",
	"Microsoft - 77-728: MOS: Microsoft Office Excel 2016 Expert",
	"Microsoft - 77-729: MOS: Microsoft Office PowerPoint 2016",
	"Microsoft - 77-730: MOS: Microsoft Office Access 2016",
	"Microsoft - 77-731: MOS: Microsoft Office Outlook 2016",
	"Microsoft - MTA 98-364: Database Fundamentals",
	"Microsoft - MTA 98-366: Networking Fundamentals",
	"Microsoft - 410: Installing and Configuring Windows Server 2012",
	"Microsoft - 411: Administering Windows Server 2012",
	"Microsoft - 412: Configuring Advanced Windows Server 2012 Services",
	"Microsoft - 413: Designing and Implementing a Server Infrastructure",
	"Microsoft - 461: Querying Microsoft SQL Server 2012",
	"Microsoft - 462: Administering Microsoft SQL Server 2012 Databases",
	"Microsoft - 463: Implementing a Data Warehouse with Microsoft SQL Server 2012",
	"Microsoft - 761: Querying Data with Transact-SQL 2016",
	"Microsoft - 762: Developing SQL Databases",
	"Microsoft - 764: Administering a SQL Database Infrastructure",
	"Microsoft - 480: Programming in HTML5 with JavaScript and CSS3",
	"Microsoft - 483: Programming in C#",
	"Microsoft - 486: Developing ASP.NET MVC Web Applications",
	"Microsoft - 487: Developing Microsoft Azure and Web Services",
	"Microsoft - AZ-103: Microsoft Azure Administrator",
	"Microsoft - AZ-203: Developing Solutions for Microsoft Azure",
	"Microsoft - AZ-300: Microsoft Azure Architect Technologies",
	"Microsoft - AZ-301: Microsoft Azure Architect Design",
	"Microsoft - AZ-900: Microsoft Azure Fundamentals",
	"Microsoft - MB-900: Microsoft Dynamics 365 Fundamentals",
	"Microsoft - MS-100: Microsoft 365 Identity and Services",
	"Microsoft - MS-101: Microsoft 365 Mobility and Security",
	"Microsoft - MS-900: Microsoft 365 Fundamentals",
	"Microsoft - 777: Implementing Microsoft Azure Cosmos DB Solutions",
	"Microsoft - 778: Analyzing and Visualizing Data with Microsoft Power BI",
	"Microsoft - MB6-896: Distribution and Trade in Microsoft Dynamics 365 for Finance and Operations",
	"Microsoft - MB6-897: Microsoft Dynamics 365 for Retail",
	"Oracle - 1Z0-034: Upgrade Oracle9i/10g OCA to Oracle Database 11g OCP",
	"Oracle - 1Z0-052: Oracle Database 11g: Administration I",
	"Oracle - 1Z0-053: Oracle Database 11g: Administration II",
	"Oracle - 1Z0-060: Upgrade to Oracle Database 12c",
	"Oracle - 1Z0-062: Oracle Database 12c Administration",
	"Oracle - 1Z0-068: Oracle Database 12c: RAC and Grid Infrastructure Administrator",
	"Oracle - 1Z0-071: Oracle Database SQL</span",
	"Oracle - 1Z0-133: Oracle WebLogic Server 12c: Administration I",
	"Oracle - 1Z0-144: Oracle Database 11g: Program with PL/SQL",
	"Oracle: 1Z0-497: Oracle Database 12c Essentials",
	"Oracle: 1Z0-533: Oracle Hyperion Planning 11 Essentials",
	"Oracle - 1Z0-808: Java SE 8 Programmer I",
	"Oracle - 1Z0-900: Java EE 7 Application Developer",
	"Oracle - 1Z0-982: Oracle Enterprise Planning and Budgeting Cloud Service 2017 Implementation Essentials",
	"Oracle: 1Z0-983: Oracle Financial Consolidation and Close Cloud Service 2017 Implementation Essentials",
	"Palo Alto Networks, Inc. - PCNSE7: Palo Alto Networks Certified Network Security Engineer",
	"Pegasystems - PEGAPCSA80V1_2019: Pega Certified System Architect (PCSA) 80V1 2019",
	"Pegasystems - PEGAPCSSA80V1_2019: Pega Certified Senior System Architect (PCSSA) 80V1",
	"PeopleCert - ISACA - Cobit5 Foundation</span",
	"PeopleCert - ITIL 4 Foundation (V4)</span",
	"PeopleCert - ITIL Intermediate",
	"PeopleCert - PRINCE2® Foundation Certificate in Project Management",
	"PeopleCert - PRINCE2® Practitioner",
	"PeopleCert - PRINCE2® Agile Practitioner",
	"PMI - CAPM: Certified Associate in Project Management (CAPM)®",
	"Salesforce - Salesforce Certified Administrator (WI20)",
	"Salesforce - Salesforce Certified Advanced Administrator (WI20)",
	"Salesforce - Salesforce Certified Platform Developer I (WI20)",
	"Salesforce - Salesforce Certified Platform Developer II - Multiple Choice (WI20)",
	"Salesforce - Salesforce Certified B2C Commerce Developer (WI20)",
	"Salesforce - Salesforce Certified Sales Cloud Consultant (WI20) - CON 201",
	"Salesforce - Salesforce Certified Service Cloud Consultant (WI20)",
	"Salesforce - Salesforce Certified Einstein Analytics and Discovery Consultant (WI20)",
	"Salesforce - Salesforce Certified Community Cloud Consultant (WI20)",
	"Salesforce - Salesforce Certified Field Service Lightning Consultant (WI20)",
	"Salesforce - Salesforce Certified Nonprofit Cloud Consultant (WI20)",
	"Salesforce - Salesforce Certified Education Cloud Consultant (WI20)",
	"Salesforce - Salesforce Certified Data Architecture and Management Designer (WI20)",
	"Salesforce - Salesforce Certified B2C Commerce Technical Solution Designer (WI20)",
	"Salesforce - Salesforce Certified Integration Architecture Designer (WI20)",
	"Salesforce - Salesforce Certified Development Lifecycle and Deployment Designer (WI20)",
	"Salesforce - Salesforce Certified Sharing and Visibility Designer (WI20)",
	"Salesforce - Salesforce Certified Identity and Access Management Designer (WI20)",
	"Salesforce - Salesforce Certified Heroku Architecture Designer (WI20)",
	"Salesforce - Salesforce Certified Pardot Consultant (WI20)",
	"Salesforce - Salesforce Certified Pardot Specialist (WI20)",
	"Scrum.org - PAL I: Professional Agile Leadership™ Certification",
	"Scrum.org - PSD I: Professional Scrum Developer™ Certification",
	"Scrum.org - PSK I: Professional Scrum™ With Kanban Certification",
	"Scrum.org - PSM I: Professional Scrum Master I",
	"Scrum.org - PSM II: Professional Scrum Master II",
	"Scrum.org - PSM III: Professional Scrum Master III",
	"Scrum.org - PSPO I: Professional Scrum Product Owner™ I",
	"Scrum.org - PSPO II: Professional Scrum Product Owner™ II",
	"Scrum.org - PSPO III: Professional Scrum Product Owner™ III",
	"Scrum.org - PSU I: Professional Scrum™ With User Experience Certification",
	"Scrum.org - SPS: Scaled Professional Scrum™ Certification",
	"ServiceNow - CSA: Certified System Administrator",
	"ServiceNow - CIS: Certified Implementation Specialist - Customer Service Management",
	"ServiceNow - CIS: Certified Implementation Specialist - Financial Management",
	"ServiceNow - CIS: Certified Implementation Specialist - HR",
	"ServiceNow - CIS: Certified Implementation Specialist - Service Management",
	"ServiceNow - CIS: Certified Implementation Specialist - Service Mapping",
	"ServiceNow - CIS: Certified Implementation Specialist - Vulnerability Response",
	"VMware - 2V0-01.19: VMware vSphere 6.7 Foundations Exam 2019",
	"VMware - 2V0-21.19: Professional vSphere 6.7 Exam 2019"];
export const state = [
	"Andaman and Nicobar Islands",
	"Andhra Pradesh",
	"Arunachal Pradesh",
	"Assam",
	"Bihar",
	"Chandigarh",
	"Chhattisgarh",
	"Dadar and Nagar Haveli",
	"Daman and Diu",
	"Delhi",
	"Goa",
	"Gujarat",
	"Haryana",
	"Himachal Pradesh",
	"Jammu and Kashmir",
	"Jharkhand",
	"Karnataka",
	"Kerala",
	"Lakshadweep",
	"Madhya Pradesh",
	"Maharashtra",
	"Manipur",
	"Meghalaya",
	"Mizoram",
	"Nagaland",
	"Odisha",
	"Puducherry",
	"Punjab",
	"Rajasthan",
	"Sikkim",
	"Tamil Nadu",
	"Telangana",
	"Tripura",
	"Uttar Pradesh",
	"Uttarakhand",
	"West Bengal"];

